module.exports = __webpack_public_path__ + "img/Mover_Back.bfebd511.svg";